import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, AlertCircle } from 'lucide-react';
const problems = ['Buscás información en YouTube y grupos de Facebook que se contradicen entre sí', 'No sabés qué decirle a un dueño cuando pregunta por la comisión', 'No tenés contrato, ni protocolo, ni nada que te proteja', 'No sabés cómo cobrar en USD sin que te coman los impuestos', 'Conseguís una reunión y te quedás en blanco cuando dice "lo tengo que pensar"', 'Ves que otros escalan a 10 propiedades y vos todavía no cerraste la primera'];
export function ProblemSection() {
  return <section className="py-20 bg-white" data-id="element-195">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-196">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-197">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-198">
            ¿Cuántos meses más vas a mirar cómo otros cobran en dólares mientras
            vos seguís en pesos?
          </h2>
          <p className="text-lg text-gray-600 mb-4" data-id="element-199">
            Sabés que el modelo existe. Lo viste en redes. Alguien cercano ya lo
            hace.
          </p>
          <p className="text-lg text-gray-600 mb-4" data-id="element-200">
            Pero nadie te dio el sistema completo, adaptado a Argentina, con los
            contratos reales, los mensajes listos y el paso a paso para cerrar
            tu primera propiedad esta semana.
          </p>
          <p className="text-xl font-bold text-gray-900 mt-8" data-id="element-201">
            No es falta de capacidad. Es falta de un sistema.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-red-50 rounded-3xl p-8 md:p-10 border border-red-100" data-id="element-202">
          <div className="flex items-center gap-3 mb-8" data-id="element-203">
            <AlertCircle className="w-6 h-6 text-red-500" data-id="element-204" />
            <h3 className="text-xl font-bold text-red-900" data-id="element-205">
              Lo que pasa sin el sistema
            </h3>
          </div>

          <div className="space-y-4" data-id="element-206">
            {problems.map((problem, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-3" data-id="element-207">
                <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-208" />
                <p className="text-red-900/80 font-medium" data-id="element-209">{problem}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}